module.exports = __webpack_public_path__ + "img/price-1.c82891c5.png";